import React, { memo, useState, useEffect } from 'react'
import { makeStyles } from '@mui/styles'
import { Typography, Select, FormControl, Tooltip, IconButton, TextField, MenuItem, Stack, Accordion, AccordionDetails, AccordionSummary, Box, ListItemText, Button, Input } from '@mui/material'
import DatePicker from "react-datepicker";
import { ReactComponent as DropDownIcon } from "../../assets/icons/icon-angle-down.svg"
import { ReactComponent as DeleteIcon } from "../../assets/icons/icon-delete.svg";
import { QUICK_FILTER_TYPE } from '../../constants/quickFilter'
import moment from 'moment';
import { setHours, setMinutes } from 'date-fns'
import { CustomTooltip } from '../../utils/Reusables';

const useStyles = makeStyles(theme => ({
    formControl: {
        minWidth: "100%"
    },
    menuDropdownItem: {
        fontSize: '14px',
        color: '#202124',
        '&:hover': {
            backgroundColor: '#f6f6f6'
        }
    }
}))
const QuickFilterCondition = ({ fieldType, filterConditions, onAddCondition, onConditionChange, onDeleteCondition }) => {
    const classes = useStyles();
    const [maxStartDate, setMaxStartDate] = useState(Date.now())
    const [minEndDate, setMinEndDate] = useState(new Date("01/01/2021"))
    const [isSameDayStartTime, setIsSameDayStartTime] = useState(false)
    const [isSameDayEndTime, setIsSameDayEndTime] = useState(false)

    const handleChangeStartDate = (e,index,endDate) => {
        let value = e
        if (moment(value).isValid()) {
            let edMonth, edDay, edYear, stMonth, stDay, stYear
            let currentDateVal = value;
            setMinEndDate(currentDateVal);
            setIsSameDayEndTime(true)
            if (endDate) {
                edMonth = new Date(endDate).getMonth()
                edDay = new Date(endDate).getDay()
                edYear = new Date(endDate).getFullYear()
                stMonth = new Date(currentDateVal).getMonth()
                stDay = new Date(currentDateVal).getDay()
                stYear = new Date(currentDateVal).getFullYear()


                if (edMonth !== stMonth || edDay !== stDay || edYear !== stYear) {
                    setIsSameDayStartTime(false)
                }
                else {
                    setIsSameDayStartTime(true)
                }
            }
            else {
                setIsSameDayEndTime(true)
            }
            value = moment(value).format("YYYY-MM-DD HH:mm:ss")
        }
        else {
            setIsSameDayEndTime(false)
            setMinEndDate(new Date("01/01/2021"))
        }
        onConditionChange({target:{value:[moment(value).format("YYYY-MM-DD HH:mm:ss")]}}, 'date', index)
        //setStartDate(value)
    }

    const handleChangeEndDate = (e,index,startDate) => {
        let value = e
        if (moment(value).isValid()) {
            let edMonth, edDay, edYear, stMonth, stDay, stYear
            let currentDateVal = value;
            setMaxStartDate(currentDateVal)
            setIsSameDayStartTime(true)
            if (startDate) {
                edMonth = new Date(startDate).getMonth()
                edDay = new Date(startDate).getDay()
                edYear = new Date(startDate).getFullYear()
                stMonth = new Date(currentDateVal).getMonth()
                stDay = new Date(currentDateVal).getDay()
                stYear = new Date(currentDateVal).getFullYear()

                if (edMonth !== stMonth || edDay !== stDay || edYear !== stYear) {
                    setIsSameDayEndTime(false)
                }
                else {
                    setIsSameDayEndTime(true)
                }
            }
            else {
                setIsSameDayStartTime(true)
            }
            value.setHours(23,59,59)
            value = moment(value).format("YYYY-MM-DD HH:mm:ss")
        }
        else {
            setIsSameDayStartTime(false)
            setMaxStartDate(Date.now())
        }
        onConditionChange({target:{value:[startDate,moment(value).format("YYYY-MM-DD HH:mm:ss")]}}, 'date', index)
    }

    const handleChangeDate = (value,index) => {
        if (value === null) {
            onConditionChange({target:{value:[]}}, 'date', index)
            return
        }
        if (moment(value).isValid()) {
            onConditionChange({target:{value:[moment(value).format("YYYY-MM-DD HH:mm:ss")]}}, 'date', index)
        }
    }

    return <>
        <Typography className="text-small" variant="body2" sx={{ paddingTop: '0.2rem', paddingBottom: '0.2rem' }} >Conditions</Typography>
        {
            filterConditions.length > 0 && filterConditions.map((condition, i) => (
                <Stack direction="row" key={`filter-condition-${i}`} className="width-100" spacing={1} flexShrink={0} sx={{ my: 0 }}>
                    <Accordion className="width-100">
                        <AccordionSummary
                            expandIcon={<DropDownIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <ListItemText
                                primary={condition.label ?? `Condition #${(i + 1)}`}
                            />
                            {i > 0 && <CustomTooltip title="Delete filter">
                                <IconButton color="primary" aria-label="Delete filter" component="span" className="hover-white form-icon-btn"
                                    sx={{ p: 0, marginRight: 4 }}
                                    onClick={() => onDeleteCondition(i)} >
                                    <DeleteIcon className="filter-action-icon" />
                                </IconButton>
                            </CustomTooltip>}
                        </AccordionSummary>
                        <AccordionDetails>
                            <Box style={{ display: "block" }}>
                                <FormControl variant="outlined" className={classes.formControl}>
                                    <Typography className="text-small" variant="body2" sx={{ paddingBottom: '0.2rem' }} >Label</Typography>
                                    <TextField
                                        className="report_form_ui_input text-small"
                                        id={"quick-filter-label-" + i}
                                        label=""
                                        value={condition.label ?? ''}
                                        onChange={e => onConditionChange(e, 'label', i)}
                                        variant="outlined"
                                        size='small'
                                    />
                                </FormControl>
                                <FormControl variant="outlined" className={classes.formControl}>
                                    <Typography className='text-small' sx={{ paddingTop: '0.2rem', paddingBottom: '0.2rem' }} variant='body2'>Operator</Typography>
                                    <Select
                                        variant="outlined"
                                        className="report_form_ui_input_select text-small pl-0"
                                        id={'listType'}
                                        value={condition.operator}
                                        defaultValue={condition.operator}
                                        onChange={e => onConditionChange(e, 'operator', i)}
                                        size='small'
                                        IconComponent={DropDownIcon}
                                        MenuProps={{
                                            classes: {
                                                root: `form-select-menu`
                                            }
                                        }}
                                    >
                                        {
                                            QUICK_FILTER_TYPE[fieldType].map((filterObj, i) => (
                                                <MenuItem key={`quic-filter-condition-${i}`} value={filterObj.value}>{filterObj.label}</MenuItem>
                                            ))
                                        }
                                    </Select>
                                </FormControl>
                                {['set', 'notSet'].indexOf(condition.operator) < 0 && ['string', 'count','number'].indexOf(fieldType) > -1 && <FormControl variant="outlined" className={classes.formControl}>
                                    <Typography className="text-small" variant="body2" sx={{ paddingBottom: '0.2rem' }} >Value List</Typography>
                                    <TextField
                                        className="report_form_ui_input text-small"
                                        id={"quick-filter-values-" + i}
                                        label=""
                                        multiline
                                        maxRows={4}
                                        value={condition.values.length > 0 ? condition.values.join('\n') : ''}
                                        onChange={e => onConditionChange(e, 'values', i)}
                                        variant="outlined"
                                        size='small'
                                    />
                                </FormControl>}
                                {['time'].indexOf(fieldType) > -1 && ['inDateRange', 'notInDateRange'].indexOf(condition.operator) < 0 && <FormControl variant="outlined" className={classes.formControl}>
                                    <Typography className="text-small" variant="body2" sx={{ paddingBottom: '0.2rem' }} >Select Date</Typography>
                                    <DatePicker dateFormat="dd/MM/yyyy HH:mm:ss" className="report_form_ui_input_date" maxDate={new Date()}
                                        selected={condition.values.length > 0 ? moment(condition.values[0]).toDate() : null} onChange={e => handleChangeDate(e,i)} isClearable />
                                </FormControl>}
                                {['time'].indexOf(fieldType) > -1 && ['inDateRange', 'notInDateRange'].indexOf(condition.operator) > -1 &&
                                    <FormControl variant="outlined" className={classes.formControl}>
                                        <Typography className="text-small" variant="body2" sx={{ paddingBottom: '0.2rem' }} >Start Date</Typography>
                                        <DatePicker dateFormat="dd/MM/yyyy HH:mm:ss" className="report_form_ui_input_date"
                                            showYearDropdown={true}
                                            showMonthDropdown={true}
                                            dropdownMode="select"
                                            selected={condition.values.length > 0 ? new Date(condition.values[0]) : null} onChange={e => handleChangeStartDate(e,i,condition?.values[1])} isClearable
                                            minDate={new Date("01-01-2021 00:00:00")}
                                            maxDate={maxStartDate}
                                            minTime={new Date("2021-01-01 00:00:00")}
                                            onKeyDown={(e) => {
                                                e.preventDefault();
                                            }}
                                            onChangeRaw={(e) => e.preventDefault()}
                                            maxTime={!isSameDayStartTime ? moment.utc().endOf('day') : maxStartDate}
                                        />
                                        <br />
                                        <Typography className="text-small" variant="body2" sx={{ paddingBottom: '0.2rem' }} >End Date</Typography>
                                        <DatePicker dateFormat="dd/MM/yyyy HH:mm:ss" className="report_form_ui_input_date"
                                            showYearDropdown={true}
                                            showMonthDropdown={true}
                                            dropdownMode="select"
                                            selected={condition.values.length > 1 ? new Date(condition.values[1]) : null}
                                            onChange={e => handleChangeEndDate(e,i,condition?.values[0])} minDate={minEndDate}
                                            maxDate={new Date()}
                                            minTime={!isSameDayEndTime ? moment.utc().endOf('day') : setHours(setMinutes(new Date(), new Date(minEndDate).getMinutes()), new Date(minEndDate).getHours())}
                                            maxTime={new Date().setHours(23, 59, 59, 999)}
                                            isClearable
                                            onKeyDown={(e) => {
                                                e.preventDefault();
                                            }}
                                            onChangeRaw={(e) => e.preventDefault()}
                                        />
                                    </FormControl>
                                }
                            </Box>
                        </AccordionDetails>
                    </Accordion>
                </Stack>
            ))
        }
        <Button onClick={onAddCondition}>+ Add</Button>
    </>
}

export default memo(QuickFilterCondition)